import React from 'react'
import icon__close from '../../../asset/icon/close-icon.svg'
import pic_aq1 from '../../../asset/image/a&q1.svg'
import pic_aq2 from '../../../asset/image/a&q2.svg'
import pic_aq3 from '../../../asset/image/a&q3.svg'
import pic_aq4 from '../../../asset/image/a&q4.svg'

function ModalFAQ({
    title,
    onClose,
    limitSizeHeight,
    limitSizeWeight,
}) {
    const presetTailwind = {
        titleFAQ: "px-10 flex justify-center md:text-[14px] text-[24px] text-[#000000] font-semibold mt-4",
        detailFAQ: "md:text-[12px] text-[#000000] text-lg"
    }

    return (
        <div className='fixed w-full h-full z-20 inset-0 flex justify-center items-center bg-[#0000008f]'>
            <div className={`${limitSizeWeight ? limitSizeWeight : "w-[700px]"} ${limitSizeHeight ? limitSizeHeight : "h-[400px]"} bg-[#FFFFFF] rounded-3xl `}>
                <div className='flex justify-end my-[5px]'>
                    <img onClick={() => { onClose() }} className='md:w-[20px] md:h-[20px] w-[30px] h-[30px] mr-[30px] hover:cursor-pointer' src={icon__close} alt='' />
                </div>
                {(() => {
                    if (title === 'การตรวจเภสัชพันธุศาสตร์ คืออะไร') {
                        return (
                            <>
                                <div className={presetTailwind.titleFAQ}>
                                    {title}
                                </div>
                                <div className='w-full flex justify-center mt-7'>
                                    <div className='w-11/12 rounded-xl ring-1 ring-[#A2B5BC] md:h-[200px] h-[250px] py-2 px-5'>
                                        <span className={presetTailwind.detailFAQ}>
                                            <div className='indent-4 break-words'>
                                                เป็นการนำข้อมูลทางพันธุกรรม มาใช้ในการทำนายโอกาสการเกิดอาการแพ้ยาที่รุนแรง เป็นการประเมินก่อน
                                                ใช้ยาว่าผู้ป่วยมีโอกาสมากน้อยเพียงใดที่จะเกิดการแพ้ยา ทำให้แพทย์ผู้รักษาสามารถเลือกใช้ยาที่เหมาะสมกับ
                                                ผู้ป่วยได้ ทำให้ผู้ป่วยปลอดภัยจากการแพ้ยา และลดค่าใช้จ่ายในภาพรวมอีกด้วย
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </>
                        )
                    }

                    if (title === 'เมื่อไรที่ควรได้รับการตรวจเภสัชพันธุศาสตร์') {
                        return (
                            <>
                                <div className={presetTailwind.titleFAQ}>
                                    {title}
                                </div>
                                <div className='w-full flex justify-center mt-7'>
                                    <div className='w-11/12 rounded-xl ring-1 ring-[#A2B5BC] h-[425px] py-7 px-5 md:overflow-y-auto'>
                                        <span className={presetTailwind.detailFAQ}>เมื่อผู้ป่วยเข้ารับการรักษาที่โรงพยาบาลด้วยโรคต่อไปนี้ เช่น
                                            <div className='indent-4 break-words'>
                                                <div>
                                                    1. ภาวะกรดยูริกในเลือดสูง หรือ โรคเก๊าต์ ยาที่ใช้ในการรักษาจะเป็นยา Allopurinol
                                                </div>
                                                <div>
                                                    2. อาการปวดเส้นประสาทใบหน้า และ อาการชัก ยาที่ใช้ในการรักษาจะเป็นยา Carbamazepine
                                                </div>
                                                <div>
                                                    3. กลุ่มผู้ติดเชื้อเอชไอวี ยาที่ใช้ในการรักษาจะเป็นยา Abacavir
                                                </div>
                                                <div>
                                                    4. โรควัณโรค ยาที่ใช้ในการรักษาจะเป็นยา Isoniazid
                                                </div>
                                            </div>
                                            <br />
                                            <div className='indent-4 break-words'>
                                                อย่างไรก็ตามยาทั้งสามชนิดนี้ยังเป็นยาที่ก่อให้เกิดอาการไม่พึงประสงค์ทางผิวหนังได้ ซึ่งอาการดังกล่าวมี
                                                ทั้งชนิดไม่รุนแรง เช่น maculopapular eruption (MPE) และชนิดที่รุนแรง (severe cutaneous
                                                adverse reactions; SCARs) จากการใช้ยา Allopurinol, Carbamazepine และ Abacavir ส่วนยา
                                                Isoniazid หากผู้ป่วยไม่ได้รับการตรวจเภสัชพุนธุศาสตร์เพื่อพิจารณายาในขนาดที่เหมาะสม อาจส่งผลให้
                                                เกิดภาวะตับอักเสบได้ ดังนั้นผู้ป่วยที่ต้องเริ่มใช้ยา Allopurinol, Carbamazepine, Abacavir และ
                                                Isoniazid จะต้องทำการตรวจตรวจเภสัชพันธุศาสตร์ เพื่อหลีกเลี่ยงเหตุการณ์ไม่พึงประสงค์จากการใช้ยา
                                                และกำหนดขนาดการใช้ยาให้เหมาะสม
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </>
                        )
                    }

                    if (title === 'เมื่อผลการตรวจเป็นบวก หมายความว่าอย่างไร') {
                        return (
                            <>
                                <div className={presetTailwind.titleFAQ}>
                                    {title}
                                </div>
                                <div className='w-full flex justify-center mt-7'>
                                    <div className='flex flex-col w-11/12 rounded-xl ring-1 ring-[#A2B5BC] h-[450px] py-7 px-5 overflow-y-auto'>
                                        <span className={presetTailwind.detailFAQ}>
                                            <div className='indent-4 break-words'>
                                                ผู้ป่วยอาจมีความเสี่ยงต่อการแพ้ยา ซึ่งอาจเกิดอาการไม่พึงประสงค์ทางผิวหนัง ได้แก่ SJS/TEN, DRESS
                                                และ MPE โดยจะมีอาการที่สามารถสังเกตได้ดังต่อไปนี้
                                                1. Stevens Johnson Syndrome (SJS)
                                            </div>
                                        </span>
                                        <div className='w-full flex justify-center'>
                                            <img className='w-96 h-96' src={pic_aq1} alt=''></img>
                                        </div>
                                        <span className={presetTailwind.detailFAQ}>
                                            <div className='indent-4 break-words'>
                                                อาการ : เกิดผื่นแพ้ที่ผิวหนัง คือ ผิวหนังตายและลอกทั้งตัวนอกจากนั้นยังเกิดผื่นแพ้ยาที่เยื่อบุทั่วร่างกาย
                                                เช่น ในปาก หลอดอาหาร ลำคอ หลอดลม กล่องเสียง ช่องคลอด รูปัสสาวะ และทวารหนัก
                                                2. Toxic Epidermal Necrolysis (TEN)
                                            </div>
                                        </span>
                                        <div className='w-full flex justify-center'>
                                            <img className='w-96 h-96' src={pic_aq2} alt=''></img>
                                        </div>
                                        <span className={presetTailwind.detailFAQ}>
                                            <div className='indent-4 break-words'>
                                                อาการ : เกิดตุ่มพุพองที่ผิวหนัง อาจดูคล้ายแผลพุพอง คล้ายแผลไฟไหม้ น้ำร้อนลวก หรือ แผลถูกสารเคมี
                                                หรือ ผื่นที่เยื่อบุตา อาจดูคล้ายอาการเยื่อบุตาอักเสบ หรือ ผื่นในปาก อาจดูคล้ายแผลร้อนใน (แผลแอฟทัส)
                                                แผลเริมที่เกิดในเยื่อบุปาก
                                                3. Drug rash eosinophilia and systemic (DRESS)
                                            </div>

                                        </span>
                                        <div className='w-full flex justify-center'>
                                            <img className='w-96 h-96' src={pic_aq3} alt=''></img>
                                        </div>
                                        <span className={presetTailwind.detailFAQ}>
                                            <div className='indent-4 break-words'>
                                                อาการ : ผื่นแดงราบหรือนูน ตุ่มน้ำหรือตุ่มหนอง ผิวหนังบวมบริเวณใบหน้าหรือแขนขา มีไข้สูง ต่อมน้ำเหลือง
                                                โต การอักเสบของอวัยวะต่าง ๆ ภายในร่างกาย ภาวะตับวาย และไตวาย
                                                4. Maculopapular eruption (MPE)
                                            </div>
                                        </span>
                                        <div className='w-full flex justify-center'>
                                            <img className='w-96 h-96' src={pic_aq4} alt=''></img>
                                        </div>
                                        <span className={presetTailwind.detailFAQ}>
                                            <div className='indent-4 break-words'>
                                                อาการ : ผื่นแดงแบนราบ และผื่นนูนเล็กน้อยกระจายทั่วร่างกาย คันเล็กน้อย มีไข้ต่ำ ๆ ไอ น้ำเหลืองโต มีแผล
                                                ในปาก
                                            </div>
                                            <br />
                                            <div className='indent-4 break-words'>
                                                อย่างไรก็ตามผู้ป่วยที่มีผลการตรวจพบยีนที่มีความเสี่ยงต่อการแพ้ยา เมื่อรับประทานยาดังกล่าวอาจไม่มีการ
                                                แพ้ยาเกิดขึ้นได้เช่นกัน
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </>
                        )
                    }

                    if (title === 'ผู้ป่วยต้องเตรียมตัวอย่างไรก่อนการเก็บตัวอย่างหรือไม่') {
                        return (
                            <>
                                <div className={presetTailwind.titleFAQ}>
                                    {title}
                                </div>
                                <div className='w-full flex justify-center mt-7'>
                                    <div className='w-11/12 rounded-xl ring-1 ring-[#A2B5BC] h-[150px] py-7 px-5'>
                                        <span className={presetTailwind.detailFAQ}>
                                            <div className='indent-4 break-words'>
                                                การตรวจนี้เป็นการตรวจทางพันธุกรรม ผู้ป่วยไม่ต้องเตรียมตัวเป็นพิเศษ (ไม่ต้องอดอาหารหรือน้ำ)
                                                เก็บทุก อย่างได้ทุกเมื่อ
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </>
                        )
                    }
                    if (title === 'เมื่อผลการตรวจยีนแพ้ยาเป็นลบ หมายความว่าอย่างไร') {
                        return (
                            <>
                                <div className={presetTailwind.titleFAQ}>
                                    {title}
                                </div>
                                <div className='w-full flex justify-center mt-7'>
                                    <div className='w-11/12 rounded-xl ring-1 ring-[#A2B5BC] md:h-[290px] h-[180px] py-7 px-5'>
                                        <span className={presetTailwind.detailFAQ}>
                                            <div className='indent-4 break-words'>
                                                หากผลการตรวจระบุว่า ไม่พบยีนที่เกี่ยวข้องกับการแพ้ยา ผู้ป่วยสามารถรับประทานยา Allopurinol,
                                                Carbamazepine, Abacavir และ Isoniazid ต่อไปได้ โดยที่ยังคงต้องติดตามอาการแพ้ยาอยู่เช่นเดิม
                                                หากมีอาการหรือสงสัยได้ว่าจะมีอาการแพ้ยาเกิดขึ้นหลังจากใช้ยาดังกล่าว ให้ผู้ป่วยหยุดยาและกลับมาพบ
                                                แพทย์ทันทีเพื่อเข้ารับการประเมินอาการแพ้ยาและการรักษาที่เหมาะสม
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </>
                        )
                    }

                    if (title === 'เมื่อผลการตรวจเป็นลบ หมายความว่าอย่างไร') {
                        return (
                            <>
                                <div className={presetTailwind.titleFAQ}>
                                    {title}
                                </div>
                                <div className='w-full flex justify-center mt-7'>
                                    <div className='w-11/12 rounded-xl ring-1 ring-[#A2B5BC] h-[250px] py-7 px-5'>
                                        <span className={presetTailwind.detailFAQ}>
                                            <div className='indent-4 break-words'>
                                                หากผลการตรวจระบุว่า ไม่พบยีนที่เกี่ยวข้องกับการแพ้ยา ผู้ป่วยสามารถรับประทานยา Allopurinol,
                                                Carbamazepine, Abacavir และ Isoniazid ต่อไปได้ โดยที่ยังคงต้องติดตามอาการแพ้ยาอยู่เช่นเดิม
                                                หากมีอาการหรือสงสัยได้ว่าจะมีอาการแพ้ยาเกิดขึ้นหลังจากนี้ ให้ผู้ป่วยหยุดยาและกลับมาพบแพทย์ทันที
                                                เพื่อเข้ารับการประเมินอาการแพ้ยาและการรักษาที่เหมาะสม
                                            </div>
                                        </span>

                                    </div>
                                </div>
                            </>
                        )
                    }

                    if (title === 'เมื่อผลการตรวจยีนเป็นลบ หมายความว่าผู้ป่วยจะไม่แพ้ยา Allopurinal, Carbamazepine, Abacavir, และ Isoniazid 100% ใช่หรือไม่') {
                        return (
                            <>
                                <div className={presetTailwind.titleFAQ}>
                                    <div className='text-center'>
                                        <p>เมื่อผลการตรวจยีนเป็นลบ หมายความว่าผู้ป่วยจะไม่แพ้ยา</p>
                                        <p>Allopurinal, Carbamazepine, Abacavir, และ Isoniazid 100% ใช่หรือไม่</p>
                                    </div>
                                </div>
                                <div className='w-full flex justify-center mt-7'>
                                    <div className='w-11/12 rounded-xl ring-1 ring-[#A2B5BC] h-[230px] py-7 px-5'>
                                        <span className={presetTailwind.detailFAQ}>
                                            <div className='indent-4 break-words'>
                                                หากผลการตรวจระบุว่า ไม่พบยีนที่เกี่ยวข้องกับการแพ้ยา ผู้ป่วยสามารถรับประทานยา Allopurinol,
                                                Carbamazepine, Abacavir และ Isoniazid ต่อไปได้ โดยที่ยังคงต้องติดตามอาการแพ้ยาอยู่เช่นเดิม
                                                หากมีอาการหรือสงสัยได้ว่าจะมีอาการแพ้ยาเกิดขึ้นหลังจากใช้ยาดังกล่าว ให้ผู้ป่วยหยุดยาและกลับมาพบ
                                                แพทย์ทันทีเพื่อเข้ารับการประเมินอาการแพ้ยาและการรักษาที่เหมาะสม
                                            </div>
                                        </span>

                                    </div>
                                </div>
                            </>
                        )
                    }
                })()}
            </div>
        </div>
    )
}

export default ModalFAQ